<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Lab Test', apiMethod: 'LabTests', form: () => import('../forms/LabTestForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Sample Set Test', apiMethod: 'SampleSetTests', parentForeignKey: 'labTestId', form: () => import('../forms/SampleSetTestForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Sample Set Tests', value: 'labTestId', isCard: true, table: () => import('../tables/SampleSetTestsTable') },
                ],
                mainForm: () => import('../forms/LabTestForm'),
                claimName: 'LabTests',
                apiMethod: 'LabTests',
            }
        }
    };
</script>
